import {toggleMobileNav} from "./modules/toggle-mobile-nav";
import {initSliders} from "./modules/init-sliders";
import initJumpButton from "./modules/init-jump-button";
import toggleAccordionItem from "./modules/toggle-acordion-item";
import initLeavingSiteOverlay from "./modules/init-leaving-site-overlay";
import changeFeaturedGame from "./modules/change-featured-game";
import setFeaturedGameSize from "./modules/set-featured-game-size";
import setHeroVideoSize from "./modules/set-hero-video-size";
import initPartyStartersFilters from "./modules/init-party-starters-filters";

window.addEventListener('load', () => {
	const instagramPosts = document.querySelectorAll('.sbi_photo');
	if (instagramPosts.length > 0) {
		instagramPosts.forEach((post) => {
			post.classList.add('open-leaving-site-overlay');
		});
	}
	
	if (document.documentElement.clientWidth < 1024) {
		const bannerContents = document.querySelectorAll('#block_634fc9f2a70ce .banners-slider__content');
		if (bannerContents.length > 0) {
			let maxHeight = 0;
			bannerContents.forEach((content) => {
				if (content.clientHeight > maxHeight) {
					maxHeight = content.clientHeight;
				}
			});
			
			bannerContents.forEach((content) => {
				content.style.height = `${maxHeight}px`;
			});
		}
	}
});

window.addEventListener('resize', () => {
	const bannerContents = document.querySelectorAll('#block_634fc9f2a70ce .banners-slider__content');
	if (document.documentElement.clientWidth >= 1024) {
		if (bannerContents.length > 0) {
			bannerContents.forEach((content) => {
				content.style.height = '';
			});
		}
	} else {
		let maxHeight = 0;
		bannerContents.forEach((content) => {
			if (content.clientHeight > maxHeight) {
				maxHeight = content.clientHeight;
			}
		});
		
		bannerContents.forEach((content) => {
			content.style.height = `${maxHeight}px`;
		});
	}
});

toggleMobileNav();
initSliders();
initJumpButton();
initLeavingSiteOverlay();
toggleAccordionItem();
changeFeaturedGame();
setFeaturedGameSize();
setHeroVideoSize();
initPartyStartersFilters();


